<template>
  <div class="zsyz-list">
    <div v-for="item in list" :key="item.id" class="list-item" @click="handleClick(item)">
      <div v-show="item.projectStatus" class="status" :style="{background:getStatus(item.projectStatus)?.color }">{{ getStatus(item.projectStatus)?.label }}</div>
      <img :src="item.titlePic" alt="">
      <div class="title">
        <span v-show="item.cityName">[{{ item.cityName }}]</span>
        {{ item.title }}
      </div>
      <div class="compony text-cut">
        招商方：<span>{{ item.orgName }}</span>
      </div>
      <div class="footprint">
        <img src="@/assets/images/footprint.png" alt="">
        {{ item.click || 0 }}次浏览
      </div>
    </div>
  </div>
</template>

<script>
import {
  ZSYZ_OPTIONS
} from "@/utils/constant";
export default {
  name: "ZsyzList",
  components: {
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  computed: {
  },
  created() {},
  mounted() {},
  methods: {
    getStatus(val) {
      val = val.toUpperCase()
      return ZSYZ_OPTIONS[val]
    },
    handleClick(item) {
      if (item.noticeUrl) {
        window.open(item.noticeUrl)
      }
    }
  }
};
</script>

<style scoped lang="scss">
.zsyz-list {
  margin-top: 15px;
  display: flex;
  flex-wrap: wrap;
  .list-item {
    padding: 15px;
    width: 288.6px;
    border: 1px #e6e6e6 solid;
    background: #fff;
    margin: 0px 15px 15px 0px;
    position: relative;
    cursor: pointer;

    &:hover {
      border-color: #dd342c;
      > img {
        opacity: 0.8;
      }
    }

    &:nth-of-type(4n) {
      margin-right: 0;
    }

    .status {
      width: 70px;
      height: 24px;
      text-align: center;
      line-height: 24px;
      color: #fff;
      position: absolute;
      right: 15px;
      top: 184px;
      z-index: 1;
    }

    img {
      width: 100%;
      height: 193px;
      display: block;
    }

    .title {
      margin-top: 10px;
      line-height: 18px;
      height: 36px;
      -webkit-line-clamp: 2;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      white-space: normal;
      overflow: hidden;

      span {
        color: #dd342c;
      }
    }

    .compony {
      line-height: 24px;
      margin-top: 2px;
      height: 24px;
      span {
        color: #dd342c;
      }
    }

    .footprint {
      font-size: 12px;
      display: flex;
      align-items: center;
      img {
        width: 23px;
        height: 23px;
      }
    }
  }
}
</style>
